"use client";

import { memo } from "react";
import { servicesHeroQualityMap } from "./constants";
import { ServicesHeroQualityProps } from "./types";
import { HeroDark } from "@/components/screen/global-components/hero";

const ServicesHeroQuality = ({
  variant = "quality",
}: ServicesHeroQualityProps) => {
  return <HeroDark {...servicesHeroQualityMap[variant]} />;
};

export default memo(ServicesHeroQuality);
